import './instrument';
import './index.css';

import * as Sentry from '@sentry/react';
import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';

import { MessageScreen } from './components/message-screen';
import { App } from './App.tsx';

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <Sentry.ErrorBoundary
      fallback={
        <MessageScreen
          title="Algo deu errado"
          message="Recarregue a página e tente novamente."
        />
      }
    >
      <App />
    </Sentry.ErrorBoundary>
  </StrictMode>,
);
